import React from 'react';
import Tip from 'ati-ui-react/components/Tip';

import * as styles from './CommentTooltipWithIcon.scss';
import CommentTooltip from '../CommentTooltip/CommentTooltip';

const CommentTooltipWithIcon = ({ comment }) => (
  <Tip
    placement="top"
    theme="light"
    content={<CommentTooltip comment={comment} />}
  >
    <button className={styles.commentIcon}>&nbsp;</button>
  </Tip>
);

export default CommentTooltipWithIcon;
